import React, { useEffect } from 'react';
import './RegistryModal.css';

const registries = [
  {
    name: 'Babylist',
    emoji: '🍼',
    url: 'https://my.babylist.com/patrisha-samowitz',
  },
  {
    name: 'Amazon',
    emoji: '📦',
    url: 'https://www.amazon.com/baby-reg/patrisha-samowitz-bryan-samowitz-may-2026-vannuys/200IRECGZ2JZT',
  },
  {
    name: 'Target',
    emoji: '🎯',
    url: 'https://www.target.com/gift-registry/gift-giver?registryId=a91ccff0-f636-11f0-8e80-e5b4259f7eb1',
  },
];

function RegistryModal({ onClose }) {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  return (
    <div className="registry-overlay" onClick={onClose}>
      <div className="registry-modal" onClick={(e) => e.stopPropagation()}>
        <button className="registry-modal-close" onClick={onClose}>
          &times;
        </button>
        <div className="registry-modal-title">Baby Registry</div>
        <div className="registry-modal-links">
          {registries.map((r) =>
            r.url ? (
              <a
                key={r.name}
                className="registry-modal-link"
                href={r.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="registry-modal-emoji">{r.emoji}</span>
                {r.name}
              </a>
            ) : (
              <span key={r.name} className="registry-modal-link disabled">
                <span className="registry-modal-emoji">{r.emoji}</span>
                {r.name}
                <span className="coming-soon">coming soon</span>
              </span>
            )
          )}
        </div>
      </div>
    </div>
  );
}

export default RegistryModal;
